import { RouteConstants } from "./RouteConstants";

const urlPaths = [
  { key: RouteConstants.ROUTE_GDPR_CREATE, label: "T_USERS" },
  { key: RouteConstants.ROUTE_GDPR_LIST, label: "T_USERS" },
];

export default urlPaths;
